import { toast } from 'sonner';
import { useColumnPreferences, type ColumnPreferences, type ColumnTableId } from '@discovr/common';

/**
 * Roster wrapper around {@link useColumnPreferences} that surfaces a toast when
 * a column-visibility PUT fails. The base hook lives in `@discovr/common` and
 * deliberately carries no toast dependency, so the UI-facing feedback is added
 * here (one place, shared by all five roster tabs). The optimistic change is
 * already rolled back by the base hook — this only tells the user it didn't
 * persist so a silently-reverting checkbox isn't confusing.
 */
export function useRosterColumnPreferences(
  campaignId: string | null | undefined,
  tableId: ColumnTableId,
): ColumnPreferences {
  return useColumnPreferences(campaignId, tableId, {
    onError: () => toast.error("Couldn't save your column choices. Please try again."),
  });
}
